import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PATHS from 'utils/paths';

import { isAuthenticated } from 'app/services/auth';

interface RouteGuardProps {
  redirectTo?: string;
  children: JSX.Element;
}

export const PrivateRoute = ({
  redirectTo = PATHS.HOME,
  children,
}: RouteGuardProps): JSX.Element => {
  const location = useLocation();

  return isAuthenticated() ? (
    children
  ) : (
    <Navigate
      to={redirectTo}
      replace
      state={{
        from: location,
      }}
    />
  );
};

export const PublicRoute = ({
  redirectTo = PATHS.HOME,
  children,
}: RouteGuardProps): JSX.Element => {
  return isAuthenticated() ? <Navigate to={redirectTo} replace /> : children;
};
